// data/languages/peul/categories/animaux.ts

import { CategoryData } from '../../../../types/types';

export const animaux: CategoryData = {
  // ANIMAUX DOMESTIQUES - Vérifiés selon les sources académiques
  'Koulle': { translation: 'Animaux', translationEn: 'Animals', audio: 'Ff-Koulle', illustration: '' },
  'Kutiiru': { translation: 'Chien', translationEn: 'Dog', audio: 'Ff-Kutiiru', illustration: '🐕' },
  'Mujuuru': { translation: 'Chat', translationEn: 'Cat', audio: 'Ff-Mujuuru', illustration: '🐈' },
  'Puccu': { translation: 'Cheval', translationEn: 'Horse', audio: 'Ff-Puccu', illustration: '🐎' },
  'Nagge': { translation: 'Vache', translationEn: 'Cow', audio: 'Ff-Nagge', illustration: '🐄' },
  'Mbeewa': { translation: 'Chèvre', translationEn: 'Goat', audio: 'Ff-Mbeewa', illustration: '🐐' },
  'Mbaalu': { translation: 'Mouton', translationEn: 'Sheep', audio: 'Ff-mbaalu', illustration: '🐑' },
  'Mbabba': { translation: 'Âne', translationEn: 'Donkey', audio: 'Ff-Mbabba', illustration: '🫏' }, // Déplacé plus haut
  'Ngaari': { translation: 'Taureau', translationEn: 'Bull', illustration: '🐂' },

   'Ngeelooba': { translation: 'Chameau', translationEn: 'Camel', audio: 'Ff-Ngeelooba', illustration: '' },

    'Wojere': { translation: 'Lapin', translationEn: 'Rabbit', audio: 'Ff-Wojere', illustration: '' },

  'Sonndu': { translation: 'Oiseau', translationEn: 'Bird', audio: 'Ff-Sonndu', illustration: '' },


    'Gadu': { translation: 'Porc', translationEn: 'Pig', audio: 'Ff-Gadu', illustration: '' },

  // VOLAILLE - Avec terminologie correcte
  'Gertode': { translation: 'Poule', translationEn: 'Hen', audio: 'Ff-Gertode', illustration: '🐔' },




  // ANIMAUX SAUVAGES - Avec corrections importantes
  'Ɲiiwa': { translation: 'Éléphant', translationEn: 'Elephant', audio: 'Ff-Niiwa', illustration: '🐘' }, // Corrigé orthographe
  'Mbaroodi': { translation: 'Lion', translationEn: 'Lion', audio: 'Ff-Mbaroodi', illustration: '🦁' }, // Corrigé de "Rawaandu ladde"

  'Fowru': { translation: 'Hyène', translationEn: 'Hyena', audio: 'Ff-Fowru', illustration: '🐺' },

  'Kooba': { translation: 'Antilope', translationEn: 'Antelope', illustration: '🦌' },
  'Ngabu': { translation: 'Hippopotame', translationEn: 'Hippopotamus', audio: 'Ff-Ngabu', illustration: '🦛' },


  'Buubu nyaawel': { translation: 'Rhinocéros', translationEn: 'Rhinoceros', illustration: '🦏' },

  'Doono': { translation: 'Caméléon', translationEn: 'Chameleon', audio: 'Ff-Doono', illustration: '' },
  'Wilwilnde': { translation: 'Chauve-souris', translationEn: 'Bat', audio: 'Ff-Wilwilnde', illustration: '' },
  'Liwre': { translation: 'Faucon', translationEn: 'Falcon', audio: 'Ff-Liwre', illustration: '' },
  'Namma ngitiri': { translation: 'Hibou', translationEn: 'Owl', audio: 'Ff-Namma_ngitiri', illustration: '' },

  'Heede': { translation: 'Tortue', translationEn: 'Turtle', audio: 'Ff-Heede', illustration: '' },
  'Laadoori': { translation: 'Serpent', translationEn: 'Snake', audio: 'Ff-Laadoori', illustration: '🐍' },
  'Norwa': { translation: 'Crocodile', translationEn: 'Crocodile', audio: 'Ff-Norwa', illustration: '' },
  'Waandu': { translation: 'Singe', translationEn: 'Monkey', illustration: '' },
  'Jabala': { translation: 'Girafe', translationEn: 'Giraffe', audio: 'Ff-jabala', illustration: '' },
  'Mbabba ladde': { translation: 'Zebre', translationEn: 'Zebra', audio: 'Ff-Mbabba_ladde', illustration: '🦓' },

  // INSECTES ET ARTHROPODES

  'Nyaaka': { translation: 'Abeille', translationEn: 'Bee', illustration: '🐝' }, // Ajouté
  'Buubu': { translation: 'Mouche', translationEn: 'Fly', illustration: '🪰' } // Ajouté
};

export default animaux;

export {};
